import Api from '../../api'
import { showToast } from '../../components/toast'
import { captureFetchException } from '../../common/helpers'

// noinspection JSUnusedGlobalSymbols
export default (elements: NodeListOf<HTMLButtonElement>) => {
  elements.forEach((element) => {
    const gameId = element.getAttribute('data-favourite-game')
    const activeClass = element.getAttribute('data-favourite-game-active-class')
    element.addEventListener('click', () => {
      const favourite = element.classList.contains(activeClass)
      const errorMessage = !favourite ? 'Не удалось добавить игру в избранное' : 'Не удалось удалить игру из избранного'

      element.classList.toggle(activeClass)

      Api.post({ url: `games/favourite`, body: { gameId } })
        .then(result => {
          if (result.success) {
            showToast({
              type: 'success',
              text: result.message
            })
          } else {
            throw new Error(result.message)
          }
        })
        .catch((e) => {
          captureFetchException(e)
          showToast({
            type: 'error',
            text: errorMessage
          })
          element.classList.toggle(activeClass)
        })
    })
  })
}
